import { useRef, useState } from "react";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import {
  deleteReasonNomenclature,
  getReasonsNomenclature,
} from "../../../../../redux/api/admin.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { adminRoutes } from "../../../../../router/routesConstants";

function AdministrateReasonActionButton({
  itemId,
  crudData,
  tableContext,
}: any) {
  const dispatch = useAppDispatch();
  const [isDeleting, setIsDeleting] = useState(false);
  const isSubmitting = useRef(false);

  const handleDeleteReason = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setIsDeleting(true);

    try {
      const resultAction = await dispatch(
        deleteReasonNomenclature({ id_motiv: itemId }),
      );

      if (
        checkEndpointStatus(resultAction, deleteReasonNomenclature) ===
          endpointStatus.fulfilled &&
        tableContext.tablePagination.page &&
        tableContext.tablePagination.rowsPerPage
      ) {
        dispatch(
          getReasonsNomenclature({
            page: tableContext.tablePagination.page,
            perPage: tableContext.tablePagination.rowsPerPage,
            denumire: tableContext.tableSearch.denumire,
            type: tableContext.tableSearch.type,
          }),
        );
      }
    } finally {
      isSubmitting.current = false;
      setIsDeleting(false);
    }
  };

  return (
    <ActionMenu
      title={crudData.denumire}
      ariaLabel={`Actiuni pentru motivul ${crudData.denumire}`}
      items={[
        {
          id: "edit-reason",
          label: "Editare motiv",
          section: "manage",
          icon: "EDIT",
          tooltip: "Modifica datele acestui motiv.",
          navigate: `/${adminRoutes.administrateReason}/${itemId}`,
        },
        {
          id: "delete-reason",
          label: "Stergere motiv",
          section: "danger",
          icon: "DELETE",
          color: "error",
          loading: isDeleting,
          tooltip: "Sterge motivul dupa confirmare.",
          withConfirmationModal: {
            modalTitle: "Stergere motiv",
            modalSubtitle: `Doriti sa stergeti motivul: ${crudData.denumire}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleDeleteReason,
            modalRightButtonText: "Sterge",
            modalRightButtonColor: "error",
          },
        },
      ]}
    />
  );
}

export default AdministrateReasonActionButton;
